import { createContext, useContext } from 'react';
/** @internal Context for mobile bottom sheet components to share state and actions. */
export const MobileBottomSheetContext = createContext(null);
export function useMobileBottomSheetContext() {
    return useContext(MobileBottomSheetContext);
}
//# sourceMappingURL=useMobileBottomSheetContext.js.map